import { Plugin, DataControllerSetEvent, DocumentChangeEvent } from "ckeditor5";

import { DocumentChangeEventInfo } from "../types";

export type DataApiDecorateEvent = {
  name: "decorateEvent";
  args: [Parameters<DataApiEventDecorator["decorateEvent"]>];
  return: ReturnType<DataApiEventDecorator["decorateEvent"]>;
};

export default class DataApiEventDecorator extends Plugin {
  init() {
    this.editor.data.on<DataControllerSetEvent>(
      "set",
      (e, [, options]) => {
        if (options?.batchType?.isUndoable || options?.batchType?.isTyping) {
          return;
        }

        this.editor.model.document.once<DocumentChangeEvent>(
          "change:data",
          (e) => this.decorateEvent(e),
          { priority: "highest" },
        );
      },
      { priority: "highest" },
    );

    this.decorate("decorateEvent");
  }

  decorateEvent(e: DocumentChangeEventInfo) {
    e.state = { isDataController: true };
  }
}
